class Lottery {
  constructor ({ turnSun = 50, prizeSun = 8, turnIng, turnEnd }) {
    this.turnSun = turnSun
    this.prizeSun = prizeSun // 抽奖的个数
    this.turnIng = turnIng
    this.turnEnd = turnEnd

    this.prize = -1 // 中奖奖品
    this.index = 0 // 当前转动到的位置
    this.turnNum = 0 // 转动次数
    this.lotterySpeed = 200 // 抽奖的速率
    this.timeOut = '' // 定时器ID
    this.minTurn = 0
    this.maxTurn = 0
    this.flag = false // 是否转动着

    this.init()
  }

  init () {
    let turn = parseInt(this.turnSun * 0.1)
    this.minTurn = turn
    this.maxTurn = this.turnSun - turn
  }

  start (prize) {
    if (this.flag) return
    this.flag = true
    this.prize = prize || 2
    this.turnFn()
  }

  turnFn () {
    this.turnNum++
    this.index >= this.prizeSun ? this.index = 1 : this.index++
    (this.turnIng && typeof this.turnIng === 'function') && this.turnIng(this.index)
    if (this.turnNum >= this.turnSun && this.index === this.prize) {
      this.lotteryEndFn(this.prize)
      return false
    } else {
      if (this.turnNum >= this.minTurn && this.turnNum < this.maxTurn) {
        this.lotterySpeed = 50
      } else if (this.turnNum >= this.maxTurn) {
        this.lotterySpeed = 200
      }

      this.timeOut = setTimeout(this.turnFn.bind(this), this.lotterySpeed)
    }
  }

  lotteryEndFn (prize) {
    clearTimeout(this.timeOut)
    this.flag = false
    if (this.turnEnd && typeof this.turnEnd === 'function') {
      setTimeout(() => {
        this.turnEnd(prize)
      }, 500)
    }
  }
}

export default Lottery
